import {Flex} from '@chakra-ui/react'
import React, {useMemo} from 'react'
import Link from '../../../components/link'
import useCustomerServicePageConfig from '../hooks/use-page-config'
import {useIntl} from 'react-intl'
import {normalizeSfccLink} from '../../../utils/url'
import {FormattedMessage} from 'react-intl'

const CSBackLink = () => {
    const {locale} = useIntl()
    const pageConfig = useCustomerServicePageConfig()
    const {backLink} = pageConfig

    const normalizedlink = useMemo(
        () => normalizeSfccLink(locale, backLink?.link),
        [backLink?.link, locale]
    )

    if (!backLink) {
        return null
    }

    return (
        <Flex
            alignItems="center"
            justifyContent="center"
            pt={6}
            pb={8}
            px={4}
            data-testid="cs-back-link"
        >
            <Link to={normalizedlink} my={4} mx={8}>
                <FormattedMessage
                    id="cs.layout.back_link"
                    defaultMessage="Back to {linkLabel}"
                    values={{linkLabel: backLink.label}}
                />
            </Link>
        </Flex>
    )
}

export default CSBackLink
